import { useContext, useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import useAxios from "services/useAxios.tsx";

import AuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import toast from "react-hot-toast";
import { addCommas } from "@persian-tools/persian-tools";

import Container from "Components/LogIn/Container";

export default function OrderPayment() {
  const { execute: newFilterOrderApi } = useAxios("api2/newfilterorder");
  const { isLogged } = useContext(AuthenticationContext);
  const { orderId } = useParams();
  const [data, setData] = useState({});
  const [loginShow, setLoginShow] = useState(false);

  useEffect(() => {
    newFilterOrderApi({
      hash: orderId,
    }).then((res) => {
      console.log("object", res);

      if (res?.status == 2) {
        setData(res?.data?.[0]);
      } else if (res?.status == -2) {
        toast.error("لینک مورد نظر صحیح نیست.");
      }
    });
  }, []);
  return (
    <div className="m-5 text-center">
      <div className=" font-16-700 bg-success text-light rounded py-2 px-5 d-inline-block mb-3">
        سفارش شما با مبلغ {addCommas(data?.paid_amount)} تومان به موفقیت ثبت شد.
      </div>
      <div className="w-100 mt-3">
        {isLogged ? (
          <NavLink
            to={"/customer-panel/orders"}
            className={
              "text-decoration-none text-danger bg-warning font-14-600 m-3 p-3 rounded font-14-500"
            }
          >
            {" "}
            سفارشات
          </NavLink>
        ) : (
          <button
            className="btn bg-warning text-danger p-3 font-14-500 "
            style={{ width: 70 }}
            onClick={() => {
              setLoginShow(true);
            }}
          >
            لاگین
          </button>
        )}
      </div>
      <Container
        loginShow={loginShow}
        setLoginShow={setLoginShow}
        changeUserInformation={() => {}}
      />
    </div>
  );
}
